// extracted by mini-css-extract-plugin
module.exports = {"bottomBar":"_36oYY0","termsAndConditions":"_2EMb_K","iconsAndFeedback":"_1oJWj_","bottomIcon":"_3fyCs_","linkWithIcon":"_3Clv_6","bottomBarRedesign":"n-t8qB"};